import { useState } from 'react'
import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import { SchedulerFormFields } from './SchedulerFormFields'
import { validateSchedulerFields } from '../common/utils'
import dayjs from 'dayjs'
import _ from 'lodash'

export const SchedulerUpdateForm = ({
    asset,
    onSubmit,
    onDelete,
    onValidationError,
    readOnly,
}) => {
    const [data, setData] = useState({
        date: dayjs(asset.schedule_date),
        time: dayjs(asset.schedule_date),
        caption: asset.caption,
        publishTo: _.map(asset.publish_to, (item) => {
            // HACKY: Need to de-serialize this data into
            // objects/classes that can be used thru the client effectively
            return {
                canonicalName: item.canonical_name,
                displayName: item.display_name,
            }
        }),
    })

    const isDateFuture = (dt) => {
        return dayjs().isBefore(dt)
    }

    const handleSubmit = () => {
        let errorFields = validateSchedulerFields(data)
        if (errorFields.length > 0) {
            onValidationError(errorFields)
            return
        }

        let date = data.date
        let time = data.time
        let schedule_date = date
            .hour(time.hour())
            .minute(time.minute())
            .second(time.second())
        if (!isDateFuture(schedule_date)) {
            onValidationError(['date', 'time'])
            return
        }

        console.log('validation successful, submitting...')
        onSubmit(data)
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <SchedulerFormFields
                readOnly={readOnly}
                date={data.date}
                time={data.time}
                caption={data.caption}
                publishTo={data.publishTo}
                onChange={setData}
                fileType={asset.source_url.split('.').at(-1)}
            />
            <Box
                sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}
            >
                <Button
                    size="lg"
                    color="danger"
                    variant="outlined"
                    onClick={onDelete}
                    disabled={readOnly}
                >
                    Delete
                </Button>
                <Button size="lg" onClick={handleSubmit} disabled={readOnly}>
                    Update
                </Button>
            </Box>
        </Box>
    )
}
